import axiosInstance from "./axiosInstance";

export const obtenerReservasSocio = async (titularId) => {
    const response = await axiosInstance.get(`${process.env.REACT_APP_BASE_URL}/reservas-socio?titularId=${titularId}`,
        {
            withCredentials: true,
        }
    );
    return response;
    
}